import { render } from "./SystemManagement.vue?vue&type=template&id=6dfc22e2&scoped=true"
import script from "./SystemManagement.vue?vue&type=script&lang=js"
export * from "./SystemManagement.vue?vue&type=script&lang=js"

import "./SystemManagement.vue?vue&type=style&index=0&id=6dfc22e2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfc22e2"]])

export default __exports__